module.exports = __webpack_public_path__ + "static/img/img(22).0524e9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(22).png
// module id = 2Exc
// module chunks = 1